var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"currency"},[_vm._v(_vm._s(_vm._f("toCurrency")(_vm.params.value)))])
}
var staticRenderFns = []

export { render, staticRenderFns }